import { excerpt } from "../../components/seo/Seo";

export default function toItem(node, lang, basePath) {
  const description =
    lang === "en" && node.descriptionen ? node.descriptionen : node.description;
  const image = description.references?.find((ref) => ref.gatsbyImageData);
  return {
    id: node.id,
    title: (lang === "en" && node.titleen ? node.titleen : node.title).trim(),
    href: `${basePath}/${node.slug}`,
    date: node.publishedDate,
    image: image?.gatsbyImageData,
    text: excerpt(description.raw),
  };
}
